module.exports = "../dist/img/vendor/leaflet/dist/layers.png?a6137456ed160d7606981aa57c559898";